import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {TagSaveResponse} from '../tags/tag-save-response';
import {GoogleService} from './google-service';

@Service()
export class TagService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  getTagTemplate(id: EntityKey): Observable<Blob> {
    let url = this.urlBase + 'tagging/template/' + id.entityId + '/' + id.entityRevision;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  saveTags(key: EntityKey, fileBytes: Uint8Array): Observable<TagSaveResponse> {
    let url = this.urlBase + 'tagging/save/' + key.entityId + '/' + key.entityRevision;
    let body = fileBytes;
    return this.http.post<TagSaveResponse>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/octet-stream");
  }

}
